import Chip from "@mui/material/Chip";
import { Theme, alpha } from "@mui/material/styles";
import { PriceBookType } from "../../../types/price-book.type";
import { CATALOGUE_CHIP_HEIGHT, CHIP_TINT_OPACITY } from "../shared/constants";
import {
  PRICE_BOOK_TYPE_LABEL,
  PRICE_BOOK_TYPE_PALETTE,
  UNKNOWN_PRICE_BOOK_TYPE_LABEL,
  toPriceBookType,
} from "./constants";

interface PriceBookTypeChipProps {
  /** Nullable at the source, so the chip has to render an unknown type as well. */
  type: PriceBookType | null;
  /** Table cells give the chip the whole column; the detail header sizes it to its text. */
  fullWidth?: boolean;
}

/** ขาย / ซื้อ badge shown wherever a pricebook's type is listed. */
export default function PriceBookTypeChip({
  type,
  fullWidth = false,
}: PriceBookTypeChipProps) {
  const knownType = toPriceBookType(type);

  // A pricebook with no type has no palette of its own; it reads as plain grey text
  // rather than taking one of the two meanings it has not been given.
  const chipColor = (theme: Theme): string =>
    knownType
      ? theme.palette[PRICE_BOOK_TYPE_PALETTE[knownType]].main
      : theme.palette.text.secondary;

  return (
    <Chip
      label={
        knownType
          ? PRICE_BOOK_TYPE_LABEL[knownType]
          : UNKNOWN_PRICE_BOOK_TYPE_LABEL
      }
      variant="outlined"
      size="small"
      sx={{
        width: fullWidth ? "100%" : "auto",
        height: CATALOGUE_CHIP_HEIGHT,
        fontWeight: 500,
        borderColor: chipColor,
        color: chipColor,
        bgcolor: (theme) => alpha(chipColor(theme), CHIP_TINT_OPACITY),
      }}
    />
  );
}
